import { Button, ColumnTable, Icon } from '@octano/global-ui';
import { useMemo } from 'react';
import { Badge } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { formatDate } from '../../../../utils/dates';

export const useColumns = () => {
  const { t } = useTranslation('academic-offer/admission-processes');
  const history = useHistory();

  const columns = useMemo<ColumnTable<any>[]>(
    () => [
      {
        headerText: t('table.processName'),
        thClassName: 'text-left pl-5',
        tdClassName: 'text-left pl-5',
        width: '300px',
        columnName: 'name',
        cellFormat: ({ row }: any) => `${row.process?.name}`,
      },
      {
        headerText: t('table.processType'),
        thClassName: 'text-center',
        columnName: 'processType',
        cellFormat: ({ row }: any) => row.process?.tuitionProcessType?.name,
      },
      {
        headerText: t('table.academicPeriod'),
        thClassName: 'text-center',
        columnName: 'period',
        cellFormat: ({ row }: any) => row.process?.academicOffer?.period?.name,
      },
      {
        headerText: t('table.startDate'),
        thClassName: 'text-center',
        columnName: 'startDate',
        cellFormat: ({ row }: any) =>
          row.process?.startedAt
            ? formatDate(row.process.startedAt, 'DD/MM/YYYY')
            : '-',
      },
      {
        headerText: t('table.endDate'),
        thClassName: 'text-center',
        columnName: 'endDate',
        cellFormat: ({ row }: any) =>
          row.process?.endedAt
            ? formatDate(row.process.endedAt, 'DD/MM/YYYY')
            : '-',
      },
      {
        headerText: t('table.multiTuition'),
        thClassName: 'text-center',
        columnName: 'multiTuition',
        cellFormat: ({ row }: any) =>
          row.process?.isMultiTuition ? t('common.yes') : t('common.no'),
      },
      {
        headerText: t('table.quotas'),
        thClassName: 'text-center',
        columnName: 'quotas',
        cellFormat: ({ row }: any) => row.process?.totalQuota || 0,
      },
      {
        headerText: t('table.enrolled'),
        thClassName: 'text-center',
        columnName: 'enrolled',
        cellFormat: ({ row }: any) => row.process?.enrolledCount || 0,
      },
      {
        headerText: t('table.status'),
        thClassName: 'text-center',
        columnName: 'status',
        cellFormat: ({ row }: any) => (
          <div>
            <Badge
              color={row.process?.isEnabled ? 'primary' : 'danger'}
              style={{
                width: '100px',
                paddingRight: '5px',
              }}
              pill
            >
              {row.process?.isEnabled
                ? t('common.enabled')
                : t('common.disabled')}
            </Badge>
          </div>
        ),
      },
      {
        headerText: t('table.manage'),
        thClassName: 'text-center',
        columnName: 'manage',
        cellFormat: ({ row }: any) => (
          <div className="d-flex justify-content-center align-items-center">
            <Button
              text={t('table.manage')}
              size="sm"
              className="mr-2"
              onClick={() => {
                history.push(
                  `/academic-offer/admission-processes/${row.process?.id}`,
                );
              }}
            />
            <Icon name="trash" />
          </div>
        ),
      },
    ],
    [t, history],
  );

  return columns;
};
